<template>
  <div>
    <div class="card bet-board-card animate-slide-y">
      <div class="card-text">
        <div>
          <div class="mb-4 flex items-center gap-1 font-medium">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            ><path
              fill-rule="evenodd"
              d="M3 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z"
              clip-rule="evenodd"
            ></path>
            </svg> เลือกประเภทการแทง
          </div>
          <div class="grid grid-cols-2 gap-2 pb-4 sm:grid-cols-3 lg:grid-cols-5">
            <div 
              v-for="(winTab, index) in winTabs" 
              :key="index"
              class="v-popper v-popper--theme-tooltip"
            >
              <button
                class="bet-type-choice-btn w-full px-2"
                :class="{'active': selectType.includes(winTab.number_type.id)}"
                type="button"
                @click="changeStatus(winTab)"
              >
                <div class="flex items-center justify-center">
                  <div class="flex w-full items-center justify-center font-bold">
                    {{ winTab.number_type.name }}
                    <span class="pay-rate-chip chip ml-2 rounded-full text-xs font-semibold">{{ winTab.userReward | number_comma }}</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-2 flex min-h-[46px] items-center justify-between gap-2">
          <div class="flex items-center gap-1 font-medium">
            <svg
              data-v-aee14c88=""
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            ><path
              fill-rule="evenodd"
              d="M3 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z"
              clip-rule="evenodd"
            ></path></svg> กดเลข
          </div>
          <ReverseNumber
            v-if="inputDigit != 1 && !selectGameOption"
            :value="reverseNumber"
            @change="reverseNumber=!reverseNumber"
          ></ReverseNumber>
        </div>

        <div 
          v-if="selectTabNumbers[0] == 2"
          class="flex items-center justify-center gap-2 pt-2 sm:pt-0 font-bold"
        >
          <button
            class="two-digit-feature-btn h-9"
            :class="{'active': selectGameOption == OPTION_NINETEEN}"
            type="button"
            @click="onSelectGameOption(OPTION_NINETEEN)"
          >
            <div class="flex items-center justify-center font-bold">
              19 ประตู
            </div>
          </button>
          <button
            class="two-digit-feature-btn h-9"
            type="button"
            :class="{'active': selectGameOption == OPTION_FRONT_ROOT}"
            @click="onSelectGameOption(OPTION_FRONT_ROOT)"
          >
            <div class="flex items-center justify-center font-bold">
              รูดหน้า
            </div>
          </button>
          <button
            class="two-digit-feature-btn h-9"
            type="button"
            :class="{'active': selectGameOption == OPTION_BACK_ROOT}"
            @click="onSelectGameOption(OPTION_BACK_ROOT)"
          >
            <div class="flex items-center justify-center font-bold">
              รูดหลัง
            </div>
          </button>
        </div>

        <num-pad
          :max-digit="inputDigit"
          @enter="onEnter"
        ></num-pad>
      </div>
    </div>
  </div>
</template>
<script>
import numPad from './NumPad2'
import ReverseNumber from './ReverseNumber'
import { findPermutations } from '@/plugins/helper'

const OPTION_NINETEEN = 'nineteen'
const OPTION_FRONT_ROOT = 'front_root'
const OPTION_BACK_ROOT = 'back_root'

export default {
  components:{
    numPad,
    ReverseNumber
  },
  props : {
    switchToggle : {
      type:Boolean,
      default:false
    },
    indexSelect : { 
      type:Number,
      default:0
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    filterNumber:{
      type:String,
      default:()=>''
    },     
    voucher:{
      type:Object,
      default:()=>{}
    },
    winTabs: {
      type: Array,
      default: () => {
        return []
      }
    }
  },   
  data (){
    return { 
      selectAmount: [],
      selectType: [], 
      toggleSelected: 0,
      selectAmountBase: [],
      LIMITL : 2, 
      ALMOST : 1, 
      NORMAL : 0,
      winNumber: '',
      unSelectAmount: [],
      selectGameOption: null,
      reverseNumber: false
    }
  },
  
  computed : {
    OPTION_NINETEEN: () => OPTION_NINETEEN,
    OPTION_FRONT_ROOT: () => OPTION_FRONT_ROOT,
    OPTION_BACK_ROOT: () => OPTION_BACK_ROOT,
    selectWinTabs () { 
      return this.winTabs.filter((x) => this.selectType.includes(x.number_type.id));
    },
    selectTabNumbers () {
      return this.selectWinTabs.map(x => x.number_type.digit)
    },
    inputDigit () {
      
      if (this.selectGameOption) {
        return 1
      }

      return this.selectTabNumbers[0]
    }
  },
  
  watch:{   
    indexSelect () { 
      this.checkStatusActive()
    },
    toggleSelected () { 
      this.checkStatusActive()
    },

    userSelect () {
      this.checkStatusActive()
    },

    winNumber () {
      this.unSelectAmount = []
    },
  }, 
  async created () { 
    this.checkStatusActive()
    this.selectType.push(this.winTabs[0].number_type.id)
  },
  methods: {

    generateResult (item, number, index) {

      let results = []

      for (let i = 0; i <= 99; i++) {
        
        let numberString = i.toString().padStart(2, '0')

        if (this.selectGameOption == OPTION_NINETEEN && !numberString.includes(number)) {
          continue
        }

        if (this.selectGameOption == OPTION_FRONT_ROOT && numberString[0] != number) {
          continue
        }

        if (this.selectGameOption == OPTION_BACK_ROOT && numberString[1] != number) {
          continue
        }

        let result = {
          value : i,
          valueUnique: `${numberString}:${item.number_type.id}`,
          number : numberString,
          status : this.NORMAL,
          userReward : 0,
          index: index,
        } 

        let limitFind = (item.limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        results.push(result);
      }
    
      return results
    },

    generateReverseResult (item, numbers, index) {

      let results = []

      numbers.forEach(i => {

        let result = {
          value : i,
          valueUnique: `${i}:${item.number_type.id}`,
          number : i.toString().padStart(item.number_type.digit, '0'),
          status : this.NORMAL,
          userReward : 0,
          index: index,
        } 

        let limitFind = (item.limit_conditions || []).filter(x => x.number === result.number) 

        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        results.push(result);
    });
        
      return results
    },

    onEnter (x) {

      for (let i = 0; i < this.winTabs.length; i++) {
        if (!this.selectType.includes(this.winTabs[i].number_type.id)) {
          continue
        }

        // if (this.selectAmount.includes(item.valueUnique)) {
        //     return;
        //   }

        if (this.reverseNumber && !this.selectGameOption) {
          const permutations = this.getPermutations(x, x.length)

          let results = this.generateReverseResult(this.winTabs[i], permutations, i)
          
          results.forEach(x => {
            this.addValue(x)
          });

          continue;
        }

        if (this.selectGameOption) {

          let results = this.generateResult(this.winTabs[i], x, i)

          results.forEach(x => {
            this.addValue(x)
          });

          continue;
        }

        let result = {
          value : x,
          valueUnique: `${x}:${this.winTabs[i].number_type.id}`,
          number : this.changeNumbertoString(x),
          status : this.NORMAL,
          userReward : 0,
          index: i
        } 

        let limitFind = (this.winTabs[i].limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        this.addValue(result)
      }

      this.winNumber = ''
    },

    onSelectGameOption (option) {

      if (this.selectGameOption == option) {
        this.selectGameOption = null
        return
      }

      this.selectGameOption = option
    },

    getPermutations (str, length) {
      if (length === 1) return str.split('');

      const perms = new Set();
      for (let i = 0; i < str.length; i++) {
        const char = str[i];
        const remainingChars = str.slice(0, i) + str.slice(i + 1);
        const remainingPerms = this.getPermutations(remainingChars, length - 1);
        for (const perm of remainingPerms) {
          perms.add(char + perm);
        }
      }
      return Array.from(perms);
    },

    selectAmountList (tab, index) {

      return this.getPermutations(this.winNumber, tab.number_type.digit).map(x => {

        let result = {
          value : x,
          valueUnique: `${x}:${tab.number_type.id}`,
          number : this.changeNumbertoString(x),
          status : this.NORMAL,
          userReward : 0,
          index: index
        } 

        let limitFind = (tab.limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        return result
      })
    },

    checkLimitCondition (item) { 
      let check = item.status ? item.status : null
      switch(check){
        case this.NORMAL:
          return ''
        case this.ALMOST:
          return 'red'
        case this.LIMITL:
          return 'red'
          
      }
      return '' 
    }, 

    changeStatus (item) { 

      const id = item.number_type.id

      this.$ga.event('Button', 'ToggleSelectType', 'ThreeDigitPage', item.number_type.name)
      this.$emit('changeStatus', id)
      this.checkStatusActive ()

      const index = this.selectType.indexOf(id);

      if (index !== -1 && this.selectType.length == 1) {
        return
      }
      
      if (index !== -1) {
        this.selectType.splice(index, 1);
      } else if (!this.selectTabNumbers.includes(item.number_type.digit))  {
        this.selectType = []
        this.selectType.push(id);
        this.selectGameOption = null
      } else {
        this.selectType.push(id);
      }
    }, 
    
    checkDisable (item) {
      let check = item.status ? item.status : null

      return check === this.LIMITL ? true : false
    }, 

    checkStatusActive () {
      this.resetBoardDisplay()

      this.userSelect.forEach(element => {
        this.selectAmount.push(`${element.number}:${element.number_type_id}`) 
      }); 
    },

    resetBoardDisplay () {  
      this.selectAmount = []  
    },

    changeNumbertoString (value){   
      return value.toString()  
    },

    switchNumbertoString (value) {
      return findPermutations(this.changeNumbertoString(value))
      .filter(x=>!this.selectAmount.includes(parseInt(x)))
      .map(x=>this.selectAmountBase.find(y=>y.number===x)) 
    },

    async addValue (item) {
      let changeNumbertoString = item.number

      this.$ga.event('Button', 'Add&DeleteValue', 'WinDigitPage', changeNumbertoString)

      let arrayResult = this.switchToggle && !this.selectAmount.includes(item.valueUnique) 
      ? this.switchNumbertoString (item.value)
      : [item]

      this.loopAdd(arrayResult)
    },  

    loopAdd (array) { 
      let Bypass = false 
      let stakeMaxNumber = (this.voucher.rules || {}).stake_max_number
      let checkVoucherStake = this.voucher.rules && stakeMaxNumber

      array.forEach(e=>{
        // let status = this.selectAmount.includes(e.valueUnique)

        // // do not remove existing one
        // if (status) {
        //   return;
        // }
        //  force always add
        // let actionStatus = status ? 'delValue': 'addValue'
        let actionStatus = 'addValue'
  
        if( checkVoucherStake &&
            this.userSelect.length >= parseInt(stakeMaxNumber) &&
            actionStatus === 'addValue'
        ) { 
          if(!Bypass) {  
            this.$nextTick(()=>{
              this.checkStatusActive() 
            }) 
          }
          
          Bypass = true
          return
        } 

        if (e.status !== this.LIMITL){ 
          let price = e.status === this.NORMAL ? this.winTabs[e.index].userReward : e.userReward
          this.$emit(actionStatus,price,e.number,this.winTabs[e.index].number_type.id, null, null, null)
        }
      }) 
    },

    onClickAmount (item) {
      const index = this.unSelectAmount.indexOf(item.valueUnique);

      if (index !== -1) {
        this.unSelectAmount.splice(index, 1);
      } else {
        this.unSelectAmount.push(item.valueUnique);
      }
    },

    filterNumberInput (event) {
      this.winNumber = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    }
  }
}
</script> 
<style scoped>
@media only screen and (min-width: 1264) {
  .column-five {
    flex: 0 0 10% !important;
    max-width: 10% !important;
  }
}

.win-number {
  max-width: 320px;
}

.bet-board-card {
  --tw-text-opacity: 1;
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
  color: rgb(0 0 0 / var(--tw-text-opacity));
  --tw-gradient-from: #fd9f59 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(253, 159, 89, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f5781d var(--tw-gradient-to-position);
}

.card {
  background: radial-gradient(ellipse at center top,  var(--bg-secondary-color-v2), var(--bg-secondary-color-v2), var(--bg-secondary-color-v2));
  border-style: none;
  border-radius: .5em;
}

.bet-board-card .card-text, .bet-board-card .card-title {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .bet-type-choice-btn, .bet-board-card .two-digit-feature-btn {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.bet-board-card .bet-type-choice-btn.active, .bet-board-card .two-digit-feature-btn.active {
  border-width: 1px;
  --tw-border-opacity: 1;
  background: radial-gradient(ellipse at center top, #fff, #fff);
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .bet-type-choice-btn.active .pay-rate-chip, .bet-board-card .two-digit-feature-btn.active .pay-rate-chip {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.card .card-text {
  padding: .75rem;
}

.card .card-actions {
    padding: .75rem;
}

.input-group {
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: .25rem;
  color: #374151;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  transition: all .2s cubic-bezier(.4,0,.2,1);
}

input {
  padding: .5rem .75rem;
  outline:none;
}

.preview-win-number {
  background-image: linear-gradient(to bottom, var(--bg-primary-300));
  background-color: var(--bg-primary-300);
}

.card .card-title {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 1.125rem;
  font-weight: 600;
  justify-content: space-between;
  padding: .75rem;
}

.preview-type {
  border-radius: .5rem;
  --tw-bg-opacity: 1;
  background-color: var(--bg-secondary-color-v2);
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: var(--bg-secondary-color-v2);
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn:hover, [type=button]:hover, [type=submit]:hover, button:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  filter: brightness(.9);
}

.bet-board-card .bet-type-choice-btn .pay-rate-chip, .bet-board-card .two-digit-feature-btn .pay-rate-chip {
  --tw-bg-opacity: 1;
  background-color: rgba(251, 239, 231);
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

</style>